import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { type MethodBaseOptions } from '../types';
import { client } from '../client';

export async function getOrders(options?: MethodBaseOptions) {
  const { user: userData} = useUserSession();
  if(!userData.value?.epicor_id) return [];

  const result = new AxiosRequestSender(client)
    .setUrl('ordersList')
    .setMethod('GET')
    .setProps([{customer_id: userData.value?.epicor_id}])
    .send();

  return result;
}
